import React from 'react';
import { StyledBg, StyledWrapper } from './styles';

interface IProps {
    title: string;
}

export const ExploreHeader: React.FC<IProps> = ({ title, children }) => (
    <>
        <StyledWrapper alignItems="center" justifyContent="center">
            <StyledBg />
            <h1>{title}</h1>
            {children}
        </StyledWrapper>
    </>
);
